import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class AttendancePunchTooSoonException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'AttendancePunchTooSoonException';
  }

  static fromError(error: HttpErrorResponse | Error): AttendancePunchTooSoonException {
    return new this(error.message, error);
  }
}
